import React from 'react'
import ReactDOM from 'react-dom/client'
import { hydrate } from 'react-dom'
import App from './App.tsx'
import './index.css'
import './styles/modern-lobby.css'

const rootElement = document.getElementById('root')!

// Support both development and react-snap hydration
if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement)
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}